import checkout from "./form";

const {
  formField: {
    address,
    certificate,
    email,
    fax,
    fullName,
    firstTime,
    phone,
    signer,
    supplementaryForThe,
    taxAgencyId,
    taxAgencyName,
    taxCalculationPeriod,
    taxId,
    taxId2,
    taxpayerName,
    timeSign,
    BusinessAddress,
    taxAgentContract,
    conpanyName,
    conpanyTax,
  },
} = checkout;

const initialValues = {
  [address.name]: "",
  [certificate.name]: "",
  [email.name]: "",
  [fax.name]: "",
  [fullName.name]: "",
  [firstTime.name]: false,
  [phone.name]: "",
  [signer.name]: "",
  [supplementaryForThe.name]: "",
  [conpanyName.name]: "",
  [conpanyTax.name]: "",
  [taxAgencyId.name]: "",
  [taxAgencyName.name]: "",
  [taxCalculationPeriod.name]: "",
  [taxId.name]: "",
  [taxId2.name]: "",
  [taxpayerName.name]: "",
  [timeSign.name]: "",
  [BusinessAddress.name]: "",
  [taxAgentContract.name]: "",
};

export default initialValues;
